import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { ButtonDeleteRendererComponent } from 'src/app/components/button-delete-render.components';
import { QcBoxService } from 'src/app/services/qcBox.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import { BaseApi } from 'src/backend/api/base-api';
import { PermissionService } from 'src/backend/services/permission.service';
import { event } from 'jquery';
import { map } from 'rxjs/operators';
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-QC-Box',
  templateUrl: './QC-Box.component.html',
  styleUrls: ['./QC-Box.component.scss']
})
export class QCBoxComponent implements OnInit {
  @ViewChild('displayQualityHistoryModal') displayQualityHistoryModal!: TemplateRef<any>;
  @ViewChild('displayQualityStatusModal') private displayQualityStatusModal!: TemplateRef<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('sorter1') sorter1: any;
  @ViewChild('sorter2') sorter2: any;
  @ViewChild('sorter3') sorter3: any;

  IsAccess: any = ApplicationPermission.Quality_QCBox_ACCESS;
  IsCreate: any = ApplicationPermission.Quality_QCBox_CREATE;
  IsUpdate: any = ApplicationPermission.Quality_QCBox_UPDATE;
  IsDelete: any = ApplicationPermission.Quality_QCBox_DELETE;

  qcBoxDataSource!: MatTableDataSource<any>;
  qcBoxColumns: any[] = ['BatchInfoId', 'ProcessOrder', 'PPD_Num', 'BatchNo', 'Qty', 'ResultOn', 'Remarks', 'createdOn', 'createdBy'];

  batchInfoDataSource!: MatTableDataSource<any>;
  batchInfoColumns: any[] = ['action', 'BatchInfoId', 'ProcessOrder', 'PPD_Num', 'BatchNo', 'Qty', 'ResultOn', 'Remarks', 'createdOn', 'createdBy'];

  warehouseForm!: FormGroup;
  statusForm!: any;
  groupList!: any[];
  filteredGroupList!: any[];
  batchDataList!: any[];
  plantList!: any[];
  filteredPlantList!: any[];
  itemInfoList!: any[];
  filteredItemInfoList!: any[];
  filteredItemDescList!: any[];
  processOrderList!: any[];
  filteredProcessOrderList!: any[];
  PalletId!: any;
  selectedRowIndex!: any;
  highLightedArray: any[] = [];
  breadcrumList: any;
  statusType!: any;
  remarksShowHideProperty = false;
  status!: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  batchInfoRowData: any = [];
  tempBatchInfoRowData: any[] = [];
  batchInfoColumnDefs!: any[];
  selectedBatchInfoRowData: any = [];
  selectedBatchInfoColumnDefs!: any[];
  frameworkComponents: any;
  plantSession: any;
  groupSession: any;
  statusList: any = [];
  paginationPageSize!: any;
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      wrapText: true,     // <-- HERE
      autoHeight: true,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      // BtnRenderer: BtnDownload,
    },
  };
  batchInfoGridOptions: any = {
    CodefaultlDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- & HERE
      minWidth: 225,
    },
    medalColumn: {
      width: 100,
      columnGroupShow: 'open',
      filter: false,
    },
    popupParent: document.querySelector('body'),
    floatingFilter: true,
  };
  selectedBatchInfoGridOptions: any = {
    CodefaultlDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: true, // <-- HERE
      autoHeight: true, // <-- & HERE
      minWidth: 225,
    },
    medalColumn: {
      width: 100,
      columnGroupShow: 'open',
      filter: false,
    },
    popupParent: document.querySelector('body'),
    floatingFilter: true,
  };
  gridApi!: any;
  gridColumnApi!: any;
  batchInfoGridApi!: any;
  batchInfoGridColumnApi!: any;
  selectedBatchInfoGridApi!: any;
  selectedBatchInfoGridColumnApi!: any;
  itemSearchText: string = '';
  QualityHistoryColumns = [
    { field: 'QCBatchInfoId', filter: 'agTextColumnFilter', headerName: 'QCBatchInfoId' },
    { field: 'ProcessOrder', filter: 'agTextColumnFilter', headerName: 'ProcessOrder' },
    { field: 'ItemCode', filter: 'agTextColumnFilter', headerName: 'ItemCode' },
    { field: 'ItemDesc', filter: 'agTextColumnFilter', headerName: 'ItemDesc' },
    { field: 'QCStatus', filter: 'agTextColumnFilter', headerName: 'QCStatus' },
    { field: 'Remarks', filter: 'agTextColumnFilter', headerName: 'Remarks' },
    { field: 'BatchNo', filter: 'agTextColumnFilter', headerName: 'BatchNo' },
    { field: 'Result', filter: 'agTextColumnFilter', headerName: 'Result' },
    {
      field: 'CreatedOn', filter: 'agTextColumnFilter', headerName: 'CreatedOn',
      valueFormatter: function (params: any) { return moment(params.value).format('DD/MM/YYYY HH:mm:ss') }
    },
    { field: 'CreatedBy', filter: 'agTextColumnFilter', headerName: 'CreatedBy' },
  ];
  qualityHistoryList: any = [];
  lang: any;
  ItemDescList: any[];

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private qcBoxService: QcBoxService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private baseApi: BaseApi,
    public translater: TranslaterService,
    public translate: TranslateService,
    private permissionService: PermissionService,
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); })
    this.frameworkComponents = {
      buttonDeleteRenderer: ButtonDeleteRendererComponent
    };
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.groupSession = this.baseApi.getGroupFromStorage();
    this.getLangWords();
    this.GetItemInfo();
    this.GetQualityStatus();
    this.statusType = 'Approve';
    this.status = 0;

    this.warehouseForm = this.fb.group({
      item: ['ALL'],
      itemDesc: ['ALL'],
      procOrder: ['ALL'],
      scantBatchNo: ['']
    });
    this.statusForm = this.fb.group({
      status: [''],
      remarks: ['']
    });
    this.batchInfoColumnDefs = [

      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'buttonDeleteRenderer',
        cellRendererParams: {
          onClick: this.deleteBatchInfoRow.bind(this),
          label: 'Delete',
        },
        maxWidth: 80,
        minWidth: 80,
        cellStyle: { textAlign: 'center', padding: 0 },
        suppressMenu: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'BatchInfoId',
        field: 'BatchInfoId',
        filter: 'agTextColumnFilter',
        width: 120,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ProcessOrder',
        field: 'ProcessOrder',
        filter: 'agTextColumnFilter',
        width: 150,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'OperNo',
        field: 'PPD_Num',
        filter: 'agTextColumnFilter',
        width: 100,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'BatchNo',
        field: 'BatchNo',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Qty',
        field: 'Qty',
        width: 100,
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ItemCode',
        field: 'ItemCode',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ItemDescription',
        field: 'ItemDesc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ResultOn',
        field: 'ResultOn',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY hh:mm:ss a');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Remarks',
        field: 'Remarks',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'CreatedOn',
        field: 'CreatedOn',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY hh:mm:ss a');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'CreatedBy',
        field: 'CreatedBy',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
    ];
    this.selectedBatchInfoColumnDefs = [
      {
        headerName: 'Action',
        field: 'Action',
        cellRenderer: 'buttonDeleteRenderer',
        cellRendererParams: {
          onClick: this.deleteBatchInfoDataData.bind(this),
          label: 'Delete',
        },
        maxWidth: 80,
        minWidth: 80,
        cellStyle: { textAlign: 'center', padding: 0 },
        suppressMenu: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'BatchInfoId',
        field: 'BatchInfoId',
        filter: 'agTextColumnFilter',
        width: 120,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ProcessOrder',
        field: 'ProcessOrder',
        filter: 'agTextColumnFilter',
        width: 150,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'OperNo',
        field: 'PPD_Num',
        filter: 'agTextColumnFilter',
        width: 100,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'BatchNo',
        field: 'BatchNo',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Qty',
        field: 'Qty',
        width: 100,
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ItemCode',
        field: 'ItemCode',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ItemDescription',
        field: 'ItemDesc',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'ResultOn',
        field: 'ResultOn',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY hh:mm:ss a');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Remarks',
        field: 'Remarks',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'CreatedOn',
        field: 'CreatedOn',
        filter: 'agTextColumnFilter',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY hh:mm:ss a');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'CreatedBy',
        field: 'CreatedBy',
        filter: 'agTextColumnFilter',
        headerValueGetter: this.localizeHeader.bind(this)
      },
    ];
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    const subMenuId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    this.moduleId = userMenus.find(x => x.menuId === subMenuId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }
  filterItemDescriptions(event: any): void {
    const search = event?.data?.toLowerCase();
    if (!search) {
      this.filteredItemDescList = this.ItemDescList.slice();
      return;
    }
    this.filteredItemDescList = this.ItemDescList.filter(item =>
      item?.toLowerCase().includes(search)
    );
  }
  openpanel(): void {
    this.filteredItemDescList = this.ItemDescList.slice();
  }
  GetItemInfo(): void {
    // this.batchInfoDataSource = new MatTableDataSource<any>([]);
    this.selectedBatchInfoRowData = [];
    const key = {
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode
    };
    this.spinner.show();
    this.qcBoxService.GetItemInfo(key).subscribe((res: any) => {
      this.spinner.hide();
      this.itemInfoList = res.ItemInfoList;
      this.ItemDescList = res.ItemInfoList.map((el: any) => el.ItemDesc);
      this.filteredItemInfoList = this.itemInfoList.slice();
      this.filteredItemDescList = this.ItemDescList.slice();
      const index = this.itemInfoList.findIndex((el: any) => el.ItemDesc == 'ALL');
      if (index != -1) {
        this.warehouseForm.get('item')?.setValue(this.itemInfoList[index].ItemCode);
        this.warehouseForm.get('itemDesc')?.setValue(this.itemInfoList[index].ItemDesc);
      }
      this.GetProcessOrder();
      this.GetBatchInfoList();
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  ItemChange(event: any, type: any) {
    let index: any;
    if (type == 'itemCode')
      index = this.itemInfoList.findIndex((el: any) => el.ItemCode == event.value);
    else
      index = this.itemInfoList.findIndex((el: any) => el.ItemDesc == event.value);
    this.warehouseForm.get('item')?.setValue(this.itemInfoList[index].ItemCode);
    this.warehouseForm.get('itemDesc')?.setValue(this.itemInfoList[index].ItemDesc);
    this.GetProcessOrder();
    this.GetBatchInfoList();
  }

  ProcessOrderChange(event: any) {

    const selectedTypeId = event?.value;
    const selectedProcessOrder = this.processOrderList.find((el: any) => el.TypeId === selectedTypeId);

    if (!selectedProcessOrder) return;
    if (selectedTypeId == 0) {
      this.warehouseForm.get('procOrder')?.setValue(0);
      this.GetBatchInfoList(); // Pass name for filtering
    }
    else {
      this.warehouseForm.get('procOrder')?.setValue(selectedProcessOrder.TypeId);
      this.GetBatchInfoListNew(selectedProcessOrder.TypeName); // Pass name for filtering
    }
  }

  GetBatchInfoListNew(processOrderName?: string): void {
    const key = {
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode,
      ItemCode: this.warehouseForm.value.item,
      PPId: 0
    };
    this.spinner.show();
    this.qcBoxService.GetBatchInfoList(key).subscribe((res: any) => {
      this.spinner.hide();
      const fullList = res.BatchInfoList || [];

      // Apply filter if process order name is provided
      this.batchInfoRowData = processOrderName
        ? fullList.filter((x: any) => x.ProcessOrder === processOrderName)
        : fullList;

      this.autoSizeBatchInfo();
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  GetItemInfoDesc(event: any): void {
    // this.batchInfoDataSource = new MatTableDataSource<any>([]);
    this.selectedBatchInfoRowData = [];
    const key = {
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode
    };
    this.spinner.show();
    this.qcBoxService.GetItemInfo(key).subscribe((res: any) => {
      this.spinner.hide();
      this.itemInfoList = res.ItemInfoList;
      this.filteredItemInfoList = this.itemInfoList.slice();
      this.filteredItemDescList = this.itemInfoList.slice();
      const index = this.itemInfoList.findIndex((el: any) => el.ItemDesc == 'ALL');
      if (index != -1) {
        this.warehouseForm.get('item')?.setValue(this.itemInfoList[index].ItemCode);
        this.warehouseForm.get('itemDesc')?.setValue(this.itemInfoList[index].ItemDesc);
      }
      this.GetProcessOrder();
      this.GetBatchInfoList();
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  GetDescInfoItem(event: any): void {
    // this.batchInfoDataSource = new MatTableDataSource<any>([]);
    this.selectedBatchInfoRowData = [];
    const key = {
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode
    };
    this.spinner.show();
    this.qcBoxService.GetItemInfo(key).subscribe((res: any) => {
      this.spinner.hide();
      this.itemInfoList = res.ItemInfoList;
      const index = this.itemInfoList.findIndex((el: any) => el.ItemDesc == 'ALL');
      if (index != -1) {
        this.warehouseForm.get('item')?.setValue(this.itemInfoList[index].ItemCode);
        this.warehouseForm.get('itemDesc')?.setValue(this.itemInfoList[index].ItemDesc);
      }
      this.GetProcessOrder();
      this.GetBatchInfoList();
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  GetProcessOrder(): void {
    const key = {
      ItemCode: this.warehouseForm.value.item
    };
    this.spinner.show();
    this.qcBoxService.GetProcessOrder(key).subscribe((res: any) => {
      this.spinner.hide();
      (res.masterList).unshift({ "TypeId": 0, "TypeName": "ALL" });
      this.processOrderList = res.masterList;

      this.filteredProcessOrderList = this.processOrderList.slice();
      this.warehouseForm.get('procOrder')?.setValue(0);
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went Wrong');
    });
  }

  GetBatchInfoList(): void {
    const key = {
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode,
      ItemCode: this.warehouseForm.value.item,
      PPId: 0
    };
    this.spinner.show();
    this.qcBoxService.GetBatchInfoList(key).subscribe((res: any) => {
      this.spinner.hide();
      this.batchInfoRowData = res.BatchInfoList;
      this.tempBatchInfoRowData = [...this.batchInfoRowData];
      this.autoSizeBatchInfo();
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  selectedBatchInfoList(): void {
    const key = {
      groupCode: this.groupSession?.groupCode,
      plantCode: this.plantSession?.plantCode,
      ItemCode: this.warehouseForm.value.item,
      PPId: 0
    };
    this.spinner.show();
    this.qcBoxService.GetBatchInfoList(key).subscribe((res: any) => {
      this.spinner.hide();
      this.selectedBatchInfoRowData = res.BatchInfoList;
      this.autoSizeSelectedBatchInfo();
      this.highLightedArray = this.selectedBatchInfoRowData;
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  GetQualityStatus(): void {
    this.spinner.show();
    this.qcBoxService.GetQualityStatus().subscribe((res: any) => {
      this.spinner.hide();
      this.statusList = res.masterList;
      this.statusForm.get('status')?.setValue(this.statusList[0].TypeId);
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  MoveBatchInfoDataSource(): ActiveToast<any> | void {
    if (!this.permissionService.isUserHasPermission(this.IsCreate)) return this.toaster.error("You don't have permission");
    this.selectedBatchInfoRowData = this.tempBatchInfoRowData;
  }

  clearBatchInfoDataDataNew(): void {
    this.tempBatchInfoRowData = [];
  }

  clearBatchInfoDataData(): void {
    this.selectedBatchInfoRowData = [];
  }

  deleteBatchInfoDataData(element: any): ActiveToast<any> | void {
    if (!this.permissionService.isUserHasPermission(this.IsDelete)) return this.toaster.error("You don't have permission");
    const index = this.selectedBatchInfoRowData.findIndex((x: any) => x.BatchInfoId === element.data.BatchInfoId);
    if (index > -1) {
      this.selectedBatchInfoRowData.splice(index, 1);
      const newData = [...this.selectedBatchInfoRowData];
      this.selectedBatchInfoRowData = newData;
    }
  }

  updatehighlight(event: any): ActiveToast<any> | void {
    if (!this.permissionService.isUserHasPermission(this.IsCreate)) return this.toaster.error("You don't have permission");

    const selectedRow = event.data;
    const batchInfoId = selectedRow.BatchInfoId;
    if (!this.isSelected(batchInfoId)) {
      this.selectedBatchInfoRowData.push(selectedRow);
      this.selectedBatchInfoRowData = [...this.selectedBatchInfoRowData];
      this.highLightedArray.push(batchInfoId);
    }
  }

  isSelected(batchInfoId: number): boolean {
    return this.selectedBatchInfoRowData.some(selectedRow => selectedRow.BatchInfoId === batchInfoId);
  }

  deleteBatchInfoRow(row: any): void {
    const index = this.tempBatchInfoRowData.findIndex(item => item.id === row.id);
    if (index > -1) {
      this.tempBatchInfoRowData.splice(index, 1);
      this.tempBatchInfoRowData = [...this.tempBatchInfoRowData]; // refresh the grid
    }
  }


  scanBatchNo() {
    if (this.tempBatchInfoRowData.length !== this.selectedBatchInfoRowData.length) {
      const value = this.tempBatchInfoRowData.filter((x: any) => x.BatchNo == this.warehouseForm.value.scantBatchNo)
      if (value && value.length) {
        for (const row of value) {
          if (this.selectedBatchInfoRowData.length > 0) {
            const obj = this.selectedBatchInfoRowData.find((x: any) => x.BatchInfoId === row.BatchInfoId) ? true : false;
            if (!obj) {
              this.selectedBatchInfoRowData.push(row);
              this.selectedBatchInfoRowData = [...this.selectedBatchInfoRowData];
            }
          }
          else {
            this.selectedBatchInfoRowData.push(row);
            this.selectedBatchInfoRowData = [...this.selectedBatchInfoRowData];
          }
        }
      }
      else {
        this.toaster.error('', 'Scanned Wrong Barcode!');
      }
    }
    else {
      this.toaster.error('', 'All BatchInfo Data Has Been Selected!');
    }
    this.warehouseForm.patchValue({ 'scantBatchNo': null });
  }

  warehouseHistoryModal(): void {
    this.dialog.open(this.displayQualityHistoryModal, { minWidth: '90%', height: '90vh' });
    this.GetQualityInfoHistoryList();
  }

  GetQualityInfoHistoryList(): void {
    const key = {
      plantCode: this.plantSession?.plantCode,
      ItemCode: this.warehouseForm.value.item,
    };
    this.spinner.show();
    this.qcBoxService.GetQualityInfoList(key).subscribe((res: any) => {
      this.spinner.hide();
      this.qualityHistoryList = res.QualityInfoList;
      this.autoSizeGrid();
    }, (err: any) => {
      this.spinner.hide();
      this.toaster.error('Error', 'Something Went rong');
    });
  }

  changeStatus(event: any): void {
    const typeStatus = this.statusList.find((x: any) => x.TypeId === event.value);
    this.statusType = typeStatus.TypeName;
    this.remarksShowHideProperty = this.statusType == 'Hold' || this.statusType === 'Reject' ? true : false;;
  }

  SubmitQuality(): void {
    if (this.selectedBatchInfoRowData && this.selectedBatchInfoRowData.length) {
      let arr: any = [];
      for (const palletID of this.selectedBatchInfoRowData)
        arr.push({ PallateBoxId: palletID.BatchInfoId })
      const key = {
        BoxList: arr,
        QCStatusId: this.statusForm.value.status,
        IsPallet: true,
        Remarks: this.statusForm.value.remarks
      };
      this.spinner.show();
      this.qcBoxService.SubmitQuality(key).subscribe((res: any) => {
        this.spinner.hide();
        if (res.HasError)
          this.toaster.error(res.ErrorMessage);
        else
          this.toaster.success(res.ErrorMessage);
        this.GetBatchInfoList();
        this.selectedBatchInfoRowData = [];
        this.statusForm.get('remarks')?.setValue('');
        this.dialog.closeAll();
      }, (err: any) => {
        this.spinner.hide();
        this.toaster.error('Error', 'Something Went rong');
      });
    }
    else {
      this.toaster.warning('Warning', 'Please Select The Batch Info');
    }
  }

  openPopUpViewForQualityStatus(): void {
    if (this.selectedBatchInfoRowData && this.selectedBatchInfoRowData.length) {
      if (this.statusForm.get('status').value == '') {
        this.toaster.warning('Warning', 'Please Select The Status');
      }
      else {
        this.dialog.open(this.displayQualityStatusModal, {
          minWidth: '50%',
          height: 'unset',
          disableClose: true
        });
      }
    }
    else {
      this.toaster.warning('Please Select The Batch Info');
    }

  }

  getPaginator(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      data.paginator = this.paginator.toArray()[index];
    }, 100);
  }

  applyFilterForSelectedBatchInfo(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.batchInfoDataSource.filter = filterValue.trim().toLowerCase();
  }

  // applyFilterForqcBoxDataSource(event: any): void {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.qcBoxDataSource.filter = filterValue.trim().toLowerCase();
  // }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.headerName;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi.autoSizeAllColumns();
  }

  autoSizeGrid() {
    this.gridApi.setRowData(this.qualityHistoryList);
    this.gridColumnApi.autoSizeAllColumns();
  }

  batchInfoGridReady(params: any): any {
    this.batchInfoGridApi = params.api;
    this.batchInfoGridColumnApi = params.columnApi;
    this.batchInfoGridColumnApi.autoSizeAllColumns();
  }

  autoSizeBatchInfo() {
    this.batchInfoGridApi.setRowData(this.batchInfoRowData);
    this.batchInfoGridColumnApi.autoSizeAllColumns();
  }

  selectedBatchInfoGridReady(params: any): any {
    this.selectedBatchInfoGridApi = params.api;
    this.selectedBatchInfoGridColumnApi = params.columnApi;
    this.selectedBatchInfoGridColumnApi.autoSizeAllColumns();
  }

  autoSizeSelectedBatchInfo() {
    this.selectedBatchInfoGridApi.setRowData(this.selectedBatchInfoRowData);
    this.selectedBatchInfoGridColumnApi.autoSizeAllColumns();
  }
}
